/* @jsx h */
import { defineComponent, h, PropType } from "vue";

interface City {
  slug: string;
  name: string;
  country: string;
  flag: string;
}

export const CitySelector = defineComponent({
  props: {
    cities: {
      type: Array as PropType<City[]>,
      default: () => [],
    },
    selectedCity: {
      type: String,
      default: "zurich",
    },
    onCityChange: {
      type: Function as PropType<(city: string) => void>,
      default: () => {},
    },
  },
  setup(props) {
    const handleChange = (e: Event) => {
      if (e.target) {
        const city = (e.target as HTMLSelectElement).value;
        props.onCityChange(city);
      }
    };

    return () => (
      <div class="inline-flex items-center gap-1 rounded-full border border-base-300 bg-base-100 py-1 pl-3 pr-1.5 shadow-sm">
        <span
          class="material-symbols-outlined text-lg text-primary"
          aria-hidden="true"
        >
          location_on
        </span>
        <select
          value={props.selectedCity}
          onChange={handleChange}
          class="cursor-pointer border-none bg-transparent py-1 pr-1 text-sm font-medium text-base-content focus:outline-none focus:ring-0"
        >
          {props.cities.map((city) => (
            <option key={city.slug} value={city.slug}>
              {city.flag} {city.name}
            </option>
          ))}
        </select>
      </div>
    );
  },
});
